import { Routes } from '@angular/router';
import { adminGuard, userGuard } from '@common/interfaces';
import { authGuard } from '../auth/auth.guard';

export const dashboardRoutes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./dashboard/home.component').then((m) => m.HomeComponent),
    children: [
      {
        path: 'welcome',
        loadComponent: () => import('./employee/welcome/welcome.component').then((m) => m.WelcomeComponent),
        canActivate: [authGuard, userGuard],
        data: { role: 'USER' },
      },
      {
        path: 'employee-dashboard',
        loadComponent: () =>
          import('./employee/employee-dashboard/employee-dashboard.component').then((m) => m.EmployeeDashboardComponent),
        canActivate: [authGuard, userGuard],
        data: { role: 'USER' },
        children: [
          {
            path: 'ticket/:id',
            loadComponent: () =>
              import('libs/shared/ui-components/src/lib/view-ticket-modal/view-ticket-modal.component').then(
                (m) => m.ViewTicketModalComponent,
              ),
            canActivate: [authGuard],
          },
          {
            path: 'tool-access/:id/history',
            loadComponent: () =>
              import('libs/shared/ui-components/src/lib/my-tool-access-section/my-tool-access-section.component').then(
                (m) => m.MyToolAccessSectionComponent,
              ),
            canActivate: [authGuard],
          },
        ],
      },
      {
        path: 'employee-approval',
        loadComponent: () =>
          import('./employee/employee-approval/employee-approval.component').then((m) => m.EmployeeApprovalComponent),
        canActivate: [authGuard, userGuard],
        data: { role: 'USER' },
        children: [
          {
            path: 'ticket/:id',
            loadComponent: () =>
              import('libs/shared/ui-components/src/lib/view-ticket-modal/view-ticket-modal.component').then(
                (m) => m.ViewTicketModalComponent,
              ),
            canActivate: [authGuard],
          },
        ],
      },
      {
        path: 'profile-details/:id',
        loadComponent: () => import('./admin/employee-details/employee-details.component').then((m) => m.EmployeeDetailsComponent),
        canActivate: [authGuard],
        data: { role: 'USER' },
      },

      {
        path: 'asset-team-dashboard',
        canActivate: [authGuard],
        data: { role: 'ADMIN' },
        children: [
          {
            path: '',
            redirectTo: 'coditas',
            pathMatch: 'full',
          },
          {
            path: 'coditas',
            loadComponent: () =>
              import('./admin/asset-team-dashboard/asset-team-dashboard.component').then((m) => m.AssetTeamDashboardComponent),
            canActivate: [authGuard],
          },
          {
            path: 'personal',
            loadComponent: () =>
              import('./admin/asset-team-dashboard-personal/asset-team-dashboard-personal.component').then(
                (m) => m.AssetTeamDashboardPersonalComponent,
              ),
            canActivate: [authGuard],
          },
        ],
      },
      {
        path: 'admin-ticket',
        canActivate: [authGuard],
        data: { role: 'ADMIN' },
        children: [
          {
            path: '',
            redirectTo: 'coditas',
            pathMatch: 'full',
          },
          {
            path: 'coditas',
            loadComponent: () => import('./admin/admin-ticket/admin-ticket.component').then((m) => m.AdminTicketComponent),
            canActivate: [authGuard],
          },
          {
            path: 'personal',
            loadComponent: () =>
              import('./admin/admin-ticket-personal/admin-ticket-personal.component').then((m) => m.AdminTicketPersonalComponent),
            canActivate: [authGuard],
          },
          {
            path: 'ticket/:id',
            loadComponent: () =>
              import('libs/shared/ui-components/src/lib/view-ticket-modal/view-ticket-modal.component').then(
                (m) => m.ViewTicketModalComponent,
              ),
            canActivate: [authGuard],
          },
        ],
      },
      {
        path: 'admin-approval',
        canActivate: [authGuard],
        data: { role: 'ADMIN' },
        children: [
          {
            path: '',
            redirectTo: 'coditas',
            pathMatch: 'full',
          },
          {
            path: 'coditas',
            loadComponent: () =>
              import('./admin/admin-approvals/admin-approvals.component').then((m) => m.AdminApprovalsComponent),
            canActivate: [authGuard],
          },
          {
            path: 'personal',
            loadComponent: () =>
              import('./admin/admin-approvals-personal/admin-approvals-personal.component').then(
                (m) => m.AdminApprovalsPersonalComponent,
              ),
            canActivate: [authGuard],
          },
          {
            path: 'ticket/:id',
            loadComponent: () =>
              import('libs/shared/ui-components/src/lib/view-ticket-modal/view-ticket-modal.component').then(
                (m) => m.ViewTicketModalComponent,
              ),
            canActivate: [authGuard],
          },
        ],
      },
      {
        path: 'inventory',
        loadComponent: () => import('./admin/admin-inventory/admin-inventory.component').then((m) => m.AdminInventoryComponent),
        canActivate: [authGuard],
        data: { role: 'ADMIN' },
        children: [
          {
            path: 'asset',
            loadComponent: () =>
              import('libs/shared/ui-components/src/lib/add-asset-modal/add-asset-modal.component').then((m) => m.AddAssetModalComponent),
          },
          {
            path: 'asset/:id',
            loadComponent: () =>
              import('libs/shared/ui-components/src/lib/add-asset-modal/add-asset-modal.component').then((m) => m.AddAssetModalComponent),
          },
          {
            path: 'asset-details/:id',
            loadComponent: () => import('./admin/asset-details/asset-details.component').then((m) => m.AssetDetailsComponent),
          },
        ],
      },
      {
        path: 'tool-access',
        canActivate: [authGuard],
        data: { role: 'ADMIN' },
        children: [
          {
            path: '',
            redirectTo: 'coditas',
            pathMatch: 'full',
          },
          {
            path: 'coditas',
            loadComponent: () =>
              import('./admin/tool-access-admin/tool-access-admin.component').then((m) => m.ToolAccessAdminComponent),
            canActivate: [authGuard],
          },
          {
            path: 'personal',
            loadComponent: () =>
              import('./admin/tool-access-personal/tool-access-personal.component').then(
                (m) => m.ToolAccessPersonalComponent,
              ),
            canActivate: [authGuard],
            children: [
              {
                path: 'tool-access/:id/history',
                loadComponent: () =>
                  import(
                    'libs/shared/ui-components/src/lib/my-tool-access-section/my-tool-access-section.component'
                  ).then((m) => m.MyToolAccessSectionComponent),
                canActivate: [authGuard],
              },
            ],
          },
        ],
      },
      {
        path: 'tool-access/:id/activity-log',
        loadComponent: () =>
          import('./admin/tool-access-activity-log/tool-access-activity-log.component').then(
            (m) => m.ToolAccessActivityLogComponent,
          ),
        canActivate: [authGuard],
        data: { role: 'ADMIN' },
      },
      {
        path: 'bulk-upload',
        loadComponent: () => import('./admin/admin-bulk-upload/admin-bulk-upload.component').then((m) => m.AdminBulkUploadComponent),
        canActivate: [authGuard],
        data: { role: 'ADMIN' },
      },
      {
        path: 'employee-details/:id',
        loadComponent: () => import('./admin/employee-details/employee-details.component').then((m) => m.EmployeeDetailsComponent),
        canActivate: [authGuard],
        data: { role: 'ADMIN' },
      },
      {
        path: 'offboarding',
        loadComponent: () => import('./admin/offboarding/offboarding.component').then((m) => m.OffboardingComponent),
        canActivate: [authGuard, adminGuard],
        data: { role: 'ADMIN' },
      },
      {
        path: 'offboarding/:id',
        loadComponent: () => import('./admin/offboarding/offboarding.component').then((m) => m.OffboardingComponent),
        canActivate: [authGuard, adminGuard],
        data: { role: 'ADMIN' },
      },

      // Intentional duplication — shell URL for signed-in users
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('libs/shared/ui-components/src/lib/privacy-policy/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
      },
      {
        path: 'terms-and-conditions',
        loadComponent: () =>
          import('libs/shared/ui-components/src/lib/terms-and-conditions/terms-and-conditions.component').then(
            (m) => m.TermsAndConditionsComponent,
          ),
      },
    ],
  },
  // MUST remain last — wildcard catches all unmatched paths
  { path: '**', redirectTo: '404-not-found' },
];
